function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphicLogoPaymentWeChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.769,
    height: 22.806,
    viewBox: "0 0 24.769 22.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Graphic-_-Logo-_-Payment-_-WeChat",
    "data-name": "Graphic-/-Logo-/-Payment-/-WeChat",
    transform: "translate(-5 .002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__WeChat",
    transform: "translate(5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_847",
    d: "M9.023 14.428a.823.823 0 0 1-.361.088.814.814 0 0 1-.722-.442l-.054-.124-2.278-5.16a.442.442 0 0 1-.04-.177.421.421 0 0 1 .411-.429.387.387 0 0 1 .249.088l2.66 1.974a1.177 1.177 0 0 0 .679.211 1.14 1.14 0 0 0 .422-.079L22.5 4.561A13 13 0 0 0 12.385 0C5.544 0 0 4.82 0 10.771a10.242 10.242 0 0 0 4.281 8.139.865.865 0 0 1 .361.7 1.175 1.175 0 0 1-.043.275c-.21.809-.545 2.109-.559 2.173a1.336 1.336 0 0 0-.065.312.425.425 0 0 0 .411.433.456.456 0 0 0 .238-.083l2.7-1.635a1.26 1.26 0 0 1 .661-.2 1.173 1.173 0 0 1 .361.057 14.035 14.035 0 0 0 4.043.6c6.858 0 12.385-4.825 12.385-10.771a9.614 9.614 0 0 0-1.415-4.99L9.1 14.371z",
    style: {
      fill: "#1aad19"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicLogoPaymentWeChat);
export default __webpack_public_path__ + "static/media/graphic-logo-payment-we-chat.698627ff.svg";
export { ForwardRef as ReactComponent };